module.exports = {
  gateway: {
    user: {
      info: `${process.env.RS_SELF}/gw/api/user/info`,
    },
  },
};
